export const siemWorkflowsMessages = {
  en: {
    siemWorkflows: {
      title: "Workflows",
      searchPlaceholder: "Keyword search",
      add: "Add workflow",
      reloadTooltip: "Reload",
      exportTooltip: "Export (coming soon)",
      featured: "Featured",
      notFeatured: "Not featured",
      public: "Public",
      private: "Private",
      mitre: "MITRE",
      isaca: "ISACA",
      mapped: "Mapped",
      none: "None",
      name: "Name",
      createdAt: "created on",
      updatedAt: "updated on",
      filterNamePlaceholder: "Search by name",
      description: "Description",
      filterDescriptionPlaceholder: "Search by description",
      filtersTitle: "Filters",
      filterReset: "Reset",
      filterSeverityPlaceholder: "All severities",
      filterFeaturedPlaceholder: "All",
      filterVisibilityPlaceholder: "All visibilities",
      filterStreamsLabel: "Streams",
      filterStreamsPlaceholder: "All",
      filterWithStreams: "With streams",
      filterWithoutStreams: "Without streams",
      colStreams: "Streams",
      streamsLinkedSuffix: "linked",
      streamsNone: "No streams",
      severity: "Severity",
      tags: "Tags",
      filterTagsPlaceholder: "Select tags",
      action: "Action",
      viewTooltip: "View",
      editTooltip: "Edit",
      deleteTooltip: "Delete",
      empty: "No workflows found.",
      loading: "Loading workflows...",
      dialogCreate: "Add workflow",
      dialogEdit: "Edit workflow",
      formName: "Name",
      formSeverity: "Severity",
      formTags: "Tags",
      formDescription: "Description",
      formFeatured: "Featured",
      formPublic: "Public",
      formLanguage: "Language",
      visibility: "Visibility",
      colCompany: "Company",
      visCompany: "Company",
      visCommunity: "Community",
      visPublic: "Public",
      visCompanyHint: "Only visible to members of your company",
      visCommunityHint: "Visible to all platform users",
      visPublicHint: "Published on the public site with company attribution",
      statsVisibility: "Visibility",
      statsSeverity: "Severity",
      statsMitre: "MITRE ATT&CK Tactics",
      statsIsaca: "ISACA Use Cases",
      statsTags: "Tags",
      statsOther: "Other",
      statsNone: "None",
      statsLoadFailed: "Failed to load workflow statistics.",
      chipTag: "Tag",
      chipMitre: "MITRE",
      chipIsaca: "ISACA",
    },
    siemWorkflowsNotifications: {
      tagsLoadFailed: "Failed to load tags.",
      workflowsLoadFailed: "Failed to load workflows.",
      workflowSaved: "Saved",
      workflowCreated: "Workflow created.",
      workflowUpdated: "Workflow updated.",
      saveFailed: "Save failed.",
      workflowDeleted: "Deleted",
      workflowRemoved: "Workflow deleted.",
      deleteFailed: "Delete failed.",
      confirmDelete: "Really delete this workflow?",
    },
  },
  de: {
    siemWorkflows: {
      title: "Workflows",
      searchPlaceholder: "Keyword Suche",
      add: "Workflow hinzufuegen",
      reloadTooltip: "Neu laden",
      exportTooltip: "Export (kommt bald)",
      featured: "Featured",
      notFeatured: "Nicht Featured",
      public: "Public",
      private: "Private",
      mitre: "MITRE",
      isaca: "ISACA",
      mapped: "Mapped",
      none: "None",
      name: "Name",
      createdAt: "erstellt am",
      updatedAt: "veraendert am",
      filterNamePlaceholder: "Suche nach Name",
      description: "Beschreibung",
      filterDescriptionPlaceholder: "Suche nach Beschreibung",
      filtersTitle: "Filter",
      filterReset: "Zurücksetzen",
      filterSeverityPlaceholder: "Alle Schweregrade",
      filterFeaturedPlaceholder: "Alle",
      filterVisibilityPlaceholder: "Alle Sichtbarkeiten",
      filterStreamsLabel: "Streams",
      filterStreamsPlaceholder: "Alle",
      filterWithStreams: "Mit Streams",
      filterWithoutStreams: "Ohne Streams",
      colStreams: "Streams",
      streamsLinkedSuffix: "verknüpft",
      streamsNone: "Keine Streams",
      severity: "Severity",
      tags: "Tags",
      filterTagsPlaceholder: "Tags waehlen",
      action: "Aktion",
      viewTooltip: "Ansehen",
      editTooltip: "Bearbeiten",
      deleteTooltip: "Loeschen",
      empty: "Keine Workflows gefunden.",
      loading: "Laedt Workflows...",
      dialogCreate: "Workflow hinzufuegen",
      dialogEdit: "Workflow bearbeiten",
      formName: "Name",
      formSeverity: "Severity",
      formTags: "Tags",
      formDescription: "Beschreibung",
      formFeatured: "Featured",
      formPublic: "Public",
      formLanguage: "Sprache",
      visibility: "Sichtbarkeit",
      colCompany: "Unternehmen",
      visCompany: "Unternehmen",
      visCommunity: "Community",
      visPublic: "Public",
      visCompanyHint: "Nur für Mitglieder deines Unternehmens sichtbar",
      visCommunityHint: "Für alle Plattform-Nutzer sichtbar",
      visPublicHint: "Auf der öffentlichen Seite mit Unternehmensangabe",
      statsVisibility: "Sichtbarkeit",
      statsSeverity: "Schweregrad",
      statsMitre: "MITRE ATT&CK Taktiken",
      statsIsaca: "ISACA Use Cases",
      statsTags: "Tags",
      statsOther: "Andere",
      statsNone: "Ohne",
      statsLoadFailed: "Workflow-Statistiken konnten nicht geladen werden.",
      chipTag: "Tag",
      chipMitre: "MITRE",
      chipIsaca: "ISACA",
    },
    siemWorkflowsNotifications: {
      tagsLoadFailed: "Tags laden fehlgeschlagen.",
      workflowsLoadFailed: "Workflows laden fehlgeschlagen.",
      workflowSaved: "Gespeichert",
      workflowCreated: "Workflow wurde erstellt.",
      workflowUpdated: "Workflow wurde aktualisiert.",
      saveFailed: "Speichern fehlgeschlagen.",
      workflowDeleted: "Gelöscht",
      workflowRemoved: "Workflow wurde gelöscht.",
      deleteFailed: "Löschen fehlgeschlagen.",
      confirmDelete: "Workflow wirklich löschen?",
    },
  },
};
